import React from 'react';
import Divider from '@material-ui/core/Divider';
import JourneyDetail from '../../components/JourneyDetail';

export const JourneyInsightDetail = ({ data }) => (
    <div>
        <JourneyDetail {...data} />
        <Divider inset />
    </div>
);

export default JourneyInsightDetail;


// WEBPACK FOOTER //
// ./src/pages/details/JourneyInsightDetail.js